import "./i18n";
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css"; // Optional: Imports global styles
import App from "./App"; // Imports the main App component
import "bootstrap/dist/css/bootstrap.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
